import { CONNECTED_INTEGRATION as connectedIntegration } from './connectedIntegration';
import { CONNECT_INTEGRATION_MODAL as connectIntegrationModal } from './connectIntegrationModal';
import { DELETE_INTEGRATION_MODAL as deleteIntegrationModal } from './deleteIntegrationModal';
import { NO_INTEGRATIONS as noIntegrations } from './noIntegrations';

export const INTEGRATIONS = { noIntegrations, deleteIntegrationModal, connectIntegrationModal, connectedIntegration };
